import React from 'react';
import "./BetaToolsBtn.scss";
import { IonButton, IonIcon } from '@ionic/react';
import { betaToolRedirectionURL } from '../../../utils/constants';
import { IONICWrapper } from '../../../utils/common';
import { Browser } from '@capacitor/browser';

export const handleBetaToolBtnClick = async (shipmentId: string = "") => {
    let baseUrl = IONICWrapper.details.keys && IONICWrapper.details.keys.configuration.betaToolRedirectionURL ||betaToolRedirectionURL;
    const access_token = (IONICWrapper.details.auth && IONICWrapper.details.auth.tokens.access_token) || "";
    const id_token = (IONICWrapper.details.auth && IONICWrapper.details.auth.tokens.id_token) || "";
    const token_type = (IONICWrapper.details.auth && IONICWrapper.details.auth.tokens.token_type) || "Bearer";
    const expires_in = (IONICWrapper.details.auth && IONICWrapper.details.auth.tokens.expires_in) || "3600";
    await Browser.open({ url: `${baseUrl}?id=${shipmentId}&access_token=${access_token}&token_type=${token_type}&expires_in=${expires_in}&id_token=${id_token}`,toolbarColor: "#FF6418"});
};
export const BetaToolsBtn = (props: any) => {
    return (
        <IonButton
        expand="full"
        shape="round"
        onClick={() => handleBetaToolBtnClick(props.shipmentID)}
        size="large"
        type="submit"
        className="betaToolsBtn"
        data-testid="betaToolsBtn"
      >
        <IonIcon src="assets/icon/betaTool.svg" size="10" />
        <span>Beta Tools</span>
      </IonButton>
    );
  };
  